/**
 * helpNarrations — curated, dual-host (NotebookLM-style) narration scripts
 * for the portal's help modals, keyed by ListenButton guideId.
 *
 * WHY: reading a help modal's text verbatim is mechanical — you can't "read"
 * a table aloud. These scripts are written like a two-host podcast: Clara and
 * Liam trade short turns, explain WHY before HOW, and never enumerate UI chrome.
 *
 * VOICES (fixed — current and future helps):
 *  - Clara  → Azure en-CA-ClaraNeural (female)
 *  - Liam   → Azure en-CA-LiamNeural (male)
 *
 * WRITING STYLE (follow this for every new script):
 *  - Prefer explicit dual-host turns (NotebookLM feel):
 *      { title, icon, turns: [
 *          { speaker: 'clara', speech: '…' },
 *          { speaker: 'liam', speech: '…' },
 *      ]}
 *  - Conversational and warm; hosts bounce off each other (react, then add).
 *  - Hook first. Explain WHY before HOW. Signpost transitions.
 *  - Never enumerate table cells or button names — describe what they mean.
 *  - Speak numbers and symbols as words ("twenty six percent").
 *  - Acronyms spaced for speech ("M T O", "P six", "G A").
 *  - 3–8 topic sections; each section 2+ short turns; end with a friendly send-off.
 *  - Legacy monologue `{ title, icon, speech }` still works — the player auto-splits
 *    sentences across Clara/Liam — but new scripts should use `turns`.
 *
 * ListenButton resolution order: explicit `sections` prop → this registry →
 * automatic DOM extraction (last resort, also dual-hosted).
 */

import { ESTIMATION_NARRATIONS } from './estimation';
import { OPERATIONS_NARRATIONS } from './operations';
import { SALES_DEV_NARRATIONS } from './salesDev';
import { SCHEDULE_NARRATIONS } from './schedule';
import { FORECASTING_NARRATIONS } from './forecasting';
import { ADMIN_NARRATIONS } from './admin';
import { TIME_TRACKER_NARRATIONS } from './timeTracker';
import { RESOURCES_NARRATIONS } from './resources';

export { expandDualHost, buildDualHostQueue, HOSTS, normalizeSpeaker, speakerGender, speakerLabel } from './dualHost';

export const HELP_NARRATIONS = {
  ...ESTIMATION_NARRATIONS,
  ...OPERATIONS_NARRATIONS,
  ...SALES_DEV_NARRATIONS,
  ...SCHEDULE_NARRATIONS,
  ...FORECASTING_NARRATIONS,
  ...ADMIN_NARRATIONS,
  ...TIME_TRACKER_NARRATIONS,
  ...RESOURCES_NARRATIONS,
};

export const getHelpNarration = (guideId) => HELP_NARRATIONS[guideId] || null;
